import { MonitoringInit } from 'js/components/Monitoring/Monitoring.js';
import { Polyfills } from 'js/components/Polyfills/Polyfills.js';
import { AccessibilityChecks } from 'js/components/Util/Accessibility.js';
import { OnReady } from 'js/components/Util/Browser.js';
import { Debug } from 'js/components/Util/Debug.js';
import { ImageObjectFit } from 'js/components/Image/index.js';
import { RunIfVisible } from 'js/components/RunIfVisible/index.js';
import 'script-loader!node_modules/svg4everybody/dist/svg4everybody.min.js';
import { AnalyticsDebugger } from 'ts/components/AnalyticsDebugger/AnalyticsDebugger.ts';
import { Accordion } from 'js/common/modules/Accordion.js';
import { ExitIntentModal } from  'js/components/ExitIntentModal/index.js';

export class Global {
  static init() {
    Polyfills.init();
    MonitoringInit();

    OnReady(() => {
      function checkAndDisplayLink(linkUrl, element) {
        fetch(linkUrl, { method: 'HEAD' })
          .then(response => {
            if (response.ok) {
              const ctaLink = document.querySelector(element);
              if (ctaLink) {
                ctaLink.href = linkUrl;
                ctaLink.style.display = 'block';
              }
            }
          })
          .catch(error => {
            console.error(`Error checking ${element}:`, error);
          });
      }

      let currentPageUrl = window.location.href.split('?')[0].split('#')[0];
      if (currentPageUrl.endsWith('/')) {
        currentPageUrl = currentPageUrl.slice(0, -1);
      }
      const bucksLink = currentPageUrl + '/bucks-win-you-win';
      const bluesLink = currentPageUrl + '/blues-win-you-win';
      checkAndDisplayLink(bucksLink, '.js-ctaLink-bucks');
      checkAndDisplayLink(bluesLink, '.js-ctaLink-blues');

      const thisYear = new Date().getFullYear();
      const dateSpans = document.querySelectorAll('.c-copy-date');
      for (const dateSpan of dateSpans) {
        dateSpan.innerHTML = `&copy; ${thisYear}`;
      }

      const accordionEl = document.querySelector('.Footer-localeAccordion');

      if (accordionEl) {
        new Accordion(accordionEl, {
          defaultCollapsed: () => true,
        });
      }

      ImageObjectFit();
      svg4everybody();

      if (Yext.isStaging ||
          window.location.href.includes('yextpages') ||
          window.location.href.includes('localhost')) {
        AccessibilityChecks.checkAltTags();
      }

      RunIfVisible.lazyLoadImages();

      // Provide a global callback so the client's scripts can choose when to enable Yext Analytics
      window.enableYextAnalytics = async () => {
        window.yextAnalyticsEnabled = true;
        window.enableYextAnalytics = () => {};

        const analytics = require('js/components/YextAnalytics/Analytics.js');

        if (Debug.isEnabled()) {
          window.Debugger = new AnalyticsDebugger();
        }
      };

      if (window.yextAnalyticsEnabled || Debug.isEnabled()) {
        window.enableYextAnalytics();
      }

      new ExitIntentModal();
    });
  }
}
